// get all queries
export const getAllQueries = (filters) => ({
  url: "/admin/contact",
  method: "GET",
  params: filters
});

// respond to query
export const respondQuery = ({ data, id }) => ({
  url: `/admin/contact/${id}`,
  method: "POST",
  body: { ...data },
});

// delete query
export const deleteQuery = (id) => ({
  url: `/admin/query/${id}`,
  method: "DELETE",
});

export const submitQuery = (data) => ({
  url: `/contact`,
  method: "POST",
  body: { ...data }
})